import { Box, Flex, Image, useColorModeValue } from "@chakra-ui/react";
import { Overline, H3, Subtitle2 } from "src/atoms/typography";
import { Translation } from "react-i18next";
import { useSelector } from "react-redux";
import { isFreemium } from "src/modules/auth/duck/selectors";
import More from "./More";
import starIcon from "./premium.svg";

export default function AccountCard({
  hasPremium,
  familyName,
  email,
  openRenameFamilyDialog,
  ...rest
}) {
  const bg = useColorModeValue("black4", "white20");
  const isFreeVersion = useSelector(isFreemium);
  return (
    <Translation>
      {(t) => (
        <Box borderRadius="12px" bg={bg} p="24px" position="relative" {...rest}>
          {familyName && (
            <More openRenameFamilyDialog={openRenameFamilyDialog} />
          )}
          {familyName && (
            <Overline color="lowEmphasis" mb="8px" textTransform="uppercase">
              {familyName}
            </Overline>
          )}
          <Flex alignItems="center">
            <H3 color="highEmphasis">
              {t(isFreeVersion ? "freeAccount" : "premiumTitle")}
            </H3>
            {hasPremium && <Image ml="4px" width="16px" src={starIcon} />}
          </Flex>
          {email && (
            <Subtitle2 color="mediumEmphasis" mt="2px">
              {email}
            </Subtitle2>
          )}
        </Box>
      )}
    </Translation>
  );
}
